// eslint-disable-next-line
const S4 = () => (((1+Math.random())*0x10000)|0).toString(16).substring(1)

function idGenerator() {
  // eslint-disable-next-line
  return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}

export default idGenerator;
